import { GoogleAnalyticsDataLayerService } from '.';
import { GoogleAnalyticsDataLayerParameters } from '../types';
import { Observable, of } from 'rxjs';

/**
 * Empty implementation of GoogleAnalyticsDataLayerService. Done by default for injecting on stories or places where
 * we don't need a real implementation of the interface
 */
export class NoopGoogleAnalyticsDataLayerService implements GoogleAnalyticsDataLayerService {
  fillDataLayer(): Observable<Partial<GoogleAnalyticsDataLayerParameters>> {
    return of({});
  }

  deepMerge(
    target: Partial<GoogleAnalyticsDataLayerParameters>,
    source: Partial<GoogleAnalyticsDataLayerParameters>,
  ): Partial<GoogleAnalyticsDataLayerParameters> {
    return { ...target, ...source };
  }
}
